import {
    IonIcon,
    IonText,
    IonCheckbox,
    IonBadge,
    IonRow,
    IonItem,
    IonDatetime,
    IonInput,
    IonButton
} from '@ionic/react';
import {
    Row,
    Col
} from 'reactstrap';
import {
    caretDown,
    caretUp,
 } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { OCCUPANT_TYPE, colorTheme } from '../../utils/constants';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';

const reviewTransactionsListItems = ({
    transactionId, transactionType, tenant,
     moneyIn, moneyOut, transactionDetails, showDetails,
     uniqueRowId, duplicatePayment,
      phoneNumbers, handleTransactionsSelected,
      updateCellValue, onSearchTenant,
      handleChangeTenant, tenantOptions, transaction, defaultTenantOptions, date,
      allTransactionsSelected, currency, isEditingDisabled,
      options, index
 }) => {

    const [showExtraDetails, setShowExtraDetails] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [transactionDate, setDate] = useState(date);
    const [isTenantFilterLoading, setIsTenantFilterLoading] = useState(false);
    const [assignedTenant, setAssignedTenant] = useState(tenant);

    const [extraData, setExtraData] = useState([
        {label: 'Transaction Type', value: transactionType},
        {label: 'Transaction Id', value: transactionId},
        {label: `${options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}`, value: ""},
        {label: 'Money In', value: moneyIn},
        {label: 'Money Out', value: moneyOut},
        {label: 'More Details', value: transactionDetails}
    ])

    useEffect(() => {
        let tenantLabel = tenant && tenant.length > 0 ? tenant[0].label : "N/A";
        setExtraData(prevExtraData => {
            const updatedExtraData = [...prevExtraData];
            updatedExtraData.find(data => data.label === "Transaction Type").value = transactionType;
            updatedExtraData.find(data => data.label === "Money In").value = moneyIn;
            updatedExtraData.find(data => data.label === "Money Out").value = moneyOut;
            updatedExtraData.find(data => data.label === "Transaction Id").value = transactionId;
            updatedExtraData.find(data => data.label === "More Details").value = transactionDetails;
            const tenantData = updatedExtraData.find(data => data.label === `${options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}`);
            if (tenantData) {
                tenantData.value = tenantLabel;
            }
            return updatedExtraData;
        });
    }, [tenant, transactionType, transactionId, moneyIn, moneyOut, transactionDetails]);


    useEffect(() => {
        setShowExtraDetails(showDetails);
    }, [showDetails]);

    useEffect(() => {
        setDate(date);
    }, [date]);

    useEffect(() => {
        if(allTransactionsSelected == 1){
            setIsChecked(true);
        }else if(allTransactionsSelected == 0){
            setIsChecked(false);
        }
    }, [allTransactionsSelected]);

    useEffect(() => {
        setAssignedTenant(tenant);
    }, [tenant]);

    const renderSelectTenant = () => {
        return (
            <AsyncTypeahead
                isLoading={isTenantFilterLoading}
                id={"tenant" + index}
                onSearch={async (query) => {
                    setIsTenantFilterLoading(true);
                    await onSearchTenant(query);
                    setIsTenantFilterLoading(false);
                }}
                selected={tenant? tenant : defaultTenantOptions[0]}
                disabled={isEditingDisabled || transactionType == "duplicate"}
                placeholder={`🔍 ${options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"}...`}
                clearButton
                autoComplete="off"
                onChange={(selected) => {
                    handleChangeTenant(uniqueRowId, selected);
                    setAssignedTenant(selected);
                }}
                options={tenantOptions}
                className={tenant.length !== 0 || transactionType !== "payment" ? "" : "bank-statement" }
            />
        )
    }

    const renderCheckbox = () => {
        return(
            <IonCheckbox
                id={'checkbox' + index}
                checked={isChecked}
                className='mr-2'
                disabled={isEditingDisabled}
                onIonChange={(e) => {
                    setIsChecked(e.target.checked);
                    handleTransactionsSelected(transaction, e.target.checked);
                }}
            />
        )

    }

    const renderDateInput = () => {
        return(
            <IonInput
                id={'date' + index}
                type="date"
                fill="solid"
                value={new Date(date).toISOString().split("T")[0] || ""}
                onIonChange={(e) => {setDate(e.target.value); updateCellValue("date", e.target.value, uniqueRowId)}}
                disabled={isEditingDisabled || transactionType == "duplicate" || transactionType == "withdrawal" || transactionType == "toDelete"}
            />
        )

    }

    const renderShowMore = () => {
        return(
            <p style={{ textDecoration: 'underline', textAlign: "center" }} onClick={ () => { setShowExtraDetails(!showExtraDetails)} }>Show More <IonIcon icon={!showExtraDetails ? caretDown : caretUp }></IonIcon></p>
        )
    }

    const showCaretandExtraDetails = () => {
        return(
            <IonText style={{ display: "flex" }}>
                {
                    transactionType !== "toDelete" && (transactionType !== "duplicate" ?
                        <strong>{transactionType === "payment" || transactionType === "duplicate" ? moneyIn + " " + (currency) : moneyOut + " " + (currency)}</strong> :
                        <strong>{(moneyIn || moneyOut) + " " + currency}</strong> )}&nbsp;
                {transactionType !== "toDelete" && <small>({transactionId})</small>}{" "}
                <IonIcon className="d-none d-sm-block" icon={!showExtraDetails ? caretDown : caretUp }></IonIcon>
            </IonText>
        )

    }

    const renderPayments = () => {
        return(
            <Row style={{ width: '100%', border: "1px solid grey" }} className='mb-2 mx-0 py-1 px-1 shadow-sm rounded'>
                <Row className='pt-2' style={{ display: "flex", alignItems: "center" }}>
                    <div style={{width: '25px'}} className='mx-2'>
                        {renderCheckbox()}
                    </div>

                    <Col id={'showMorePayments' + index} xs={10} sm={10} onClick={ () => { setShowExtraDetails(!showExtraDetails)} }>
                        {showCaretandExtraDetails()}
                    </Col>
                </Row>

                <Row className='my-2 mx-1 px-1' style={{ display: "flex", alignItems: "center" }}>

                    <Col id={'tenantContainer' + index} className='px-1 mx-0 my-2' xs={12} sm={12} md={5} lg={5}>
                        {renderSelectTenant()}
                    </Col>

                    <Col xs={12} sm={12} md={5} lg={5} className='my-2'>
                        {renderDateInput()}
                    </Col>

                    <Col className="d-block d-sm-none my-2">
                        {renderShowMore()}
                    </Col>
                </Row>
            </Row>
        )
    }

    const renderWithdrawals = () => {
        return(
            <Row style={{ width: '100%', border: "1px solid grey" }} className='mb-2 mx-0 py-1 px-1 shadow-sm rounded'>
                <Row className='pt-2' style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Col id={'showMoreWithdrawals' + index} xs={12} sm={12} onClick={ () => { setShowExtraDetails(!showExtraDetails)} }>
                        {showCaretandExtraDetails()}
                    </Col>
                </Row>

                <Row className='my-2 mx-1 px-1' style={{ display: "flex", alignItems: "center" }}>
                    <Col xs={12} sm={12} md={12} lg={12} className='my-2'>
                        {renderDateInput()}
                    </Col>

                    <Col className="d-block d-sm-none my-2">
                        {renderShowMore()}
                    </Col>
                </Row>
            </Row>
        )
    }

    const renderDuplicates = () => {
        return(
            <Row style={{ width: '100%', border: "1px solid grey" }} className='mb-2 mx-0 py-1 px-1 shadow-sm rounded'>
                <Row className='pt-2' style={{ display: "flex", alignItems: "center" }}>
                    <Col id={'showMoreDuplicates' + index} xs={10} sm={10} onClick={ () => { setShowExtraDetails(!showExtraDetails)} }>
                        {showCaretandExtraDetails()}
                    </Col>
                </Row>

                <Row className='my-2 mx-1 px-1' style={{ display: "flex", alignItems: "center" }}>

                    <Col className='px-1 mx-0 my-2' xs={12} sm={12} md={6} lg={6}>
                        {renderSelectTenant()}
                    </Col>

                    <Col xs={12} sm={12} md={5} lg={5} className='my-2'>
                        {renderDateInput()}
                    </Col>

                    <Col className="d-block d-sm-none my-2">
                        {renderShowMore()}
                    </Col>
                </Row>
            </Row>
        )
    }

    const renderExtraDetails = () => {
        return(
            <Row style={{ backgroundColor: colorTheme["primary"]["25"], overflowX: "hidden" }} className='ml-2 mr-3 mb-2 py-3 px-0 rounded tenant-list-row'>
                {extraData.map((data, index) => (
                    <Row key={index} className='border-bottom my-1 ml-0.5'>
                        <Col xs={12} md={3}><strong>{data.label}</strong></Col>
                        <Col xs={12} md={8}>
                            <span style={{ fontSize: '16px' }}>{data.value}</span>
                        </Col>
                    </Row>
                ))}
            </Row>
        )
    }


    return (
        <div key={uniqueRowId} className={"rounded"}>

            {transactionType == "payment" && renderPayments()}

            {transactionType == "withdrawal" && renderWithdrawals()}

            {transactionType == "duplicate" && renderDuplicates()}

            {showExtraDetails && renderExtraDetails()}
        </div>
    );
}

export default reviewTransactionsListItems;